import React from 'react';
import PropTypes from 'prop-types';
import AuthorizationListResponsiveTable from './AuthorizationListResponsiveTable';
import { FakeText } from '@totalsoft/rocket-ui';

const AuthorizationListComponent = ({
  authorizations,
  userGroups,
  dispatch,
  onRefineAuthorization,
  onUnrefineAuthorization,
  loading,
  changedPermissions
}) => {
  return loading ? (
    <FakeText lines={10} />
  ) : (
    <AuthorizationListResponsiveTable
      userGroups={userGroups}
      authorizations={authorizations}
      onRefineAuthorization={onRefineAuthorization}
      onUnrefineAuthorization={onUnrefineAuthorization}
      dispatch={dispatch}
      changedPermissions={changedPermissions}
    />
  );
};

AuthorizationListComponent.propTypes = {
  authorizations: PropTypes.array,
  userGroups: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  onRefineAuthorization: PropTypes.func.isRequired,
  onUnrefineAuthorization: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  changedPermissions: PropTypes.object
};

export default AuthorizationListComponent;
